class AccordionTab extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        console.log('accordion-tab initialized')

        this.header = this.querySelector('[data-header]');
        this.content = this.querySelector('[data-content]');

        this.header.addEventListener('click', this.handleToggle.bind(this) )
    }

    disconnectedCallback() {
        console.log('accordion-tab destroyed')
    }

    handleToggle() {
        console.log('testing')
        this.toggleAttribute('open');
    }

}

customElements.define("accordion-tab", AccordionTab)